/**
 * Window CustomEvent names for the motion editor (`craftara:*` convention).
 */

export const TOGGLE_MOTION_MODE_EVENT = 'craftara:toggle-motion-mode';
export const OPEN_VIDEO_EXPORT_EVENT = 'craftara:open-video-export';
export const OPEN_ANIMATION_PANEL_EVENT = 'craftara:open-animation-panel';
/** detail: { obj } — a clip layer's trim / rate / loop / audio changed; live playback re-syncs. */
export const VIDEO_CLIP_CHANGED_EVENT = 'craftara:video-clip-changed';
